import { createContext } from "react";

export const ActivitiesContext = createContext({
	activities: [],
	activitiesCards: [],
	isLoading: false,
	moreInfoVisible: false,
	moreInfoCard: null,

	startCard: 0,
	limit: 12,

	ageButtonActive: false,
	ageButtonId: "",
	setAgeString: () => {},

	activityButtonActive: false,
	activityButtonId: "",
	extraButtonActive: false,
	extraButtonId: "",
	branchButtonActive: false,
	branchButtonId: "",
	setActivityString: () => {},

	searchInputRef: "",
	setSearchString: () => {},

	dateButtonActive: false,
	dateButtonId: "",
	setDateString: () => {},

	locations: [],
	locationButtonId: "",
	locationButtonText: "",
	setLocationString: () => {},
	locationQuery: "",
	distanceQuery: "",
	toggleActive: false,

	distanceButtonId: "",
	setDistanceString: () => {},

	executeScroll: () => {},

	checked: false,
	sportTypeId: "",
	sportTypeString: "",
	setSportTypeString: () => {},

	dictionaryWords: [],
});
